import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
`

export const Title = styled.h2`
  font-size: ${(props) => props.theme.font.textcaption};
  font-style: normal;
  font-weight: 500;
  line-height: 100%; /* 0.75rem */
  letter-spacing: 0.00188rem;
  color: ${(props) => props.theme.color.neutral.gray};
`

export const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${(props) => props.theme.color.neutral.gray};
  opacity: 0.6;
  border-radius: 0.5rem;
`
